import { DisplayCampaignInformation } from '../../types/campaigns.type';
import { ColumnDef } from '../../types/table.type';
import Chip from '../chip';

type StatusKey = 'draft' | 'Awaiting approval' | 'Complete' | 'archived' | 'cancelled' | 'sent to api' | 'ready for review';

const statusMap: Record<StatusKey, string> = {
  draft: '',
  'Awaiting approval': 'red',
  Complete: 'green',
  archived: 'purple',
  cancelled: 'red',
  'sent to api': 'yellow',
  'ready for review': 'yellow',
};

const columns: ColumnDef<DisplayCampaignInformation>[] = [
  {
    key: 'campaignName', header: 'Campaign Name', sortable: true, sortFn: (a, b) => a.campaignName.localeCompare(b.campaignName),
  },
  { key: 'numberOfRecipients', header: 'Number of Recipients', sortable: true },
  { key: 'snapshot', header: 'LIFT Snapshot', sortable: false },
  { key: 'campaignType', header: 'Campaign Type', sortable: true },
  { key: 'communicationChannel', header: 'Communication Channel', sortable: true },
  { key: 'createdBy', header: 'Created By', sortable: false },
  { key: 'dateSent', header: 'Date Sent', sortable: false },
  {
    key: 'status',
    header: 'Status',
    sortable: true,
    render: (value: string) => (
      <Chip
        text={value}
        colour={statusMap[value as StatusKey] || ''}
        closeButton={false}
        small
      />
    ),
  },
];
export default columns;
